// extracted by css-extract-rspack-plugin
export default {"errorBannerContainer":"src-domain-components-configuration-tab-ConfigurationTab-module__errorBannerContainer-wLRzHn"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"errorBannerContainer\":\"src-domain-components-configuration-tab-ConfigurationTab-module__errorBannerContainer-wLRzHn\"}";
        // 1792611263339
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  